const IDENTIFIER = '[A-Za-z0-9_.$]'

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/gu, '\\$&')
}

export function extractMetrics(formula: string, allowedMetrics: readonly string[]): string[] {
  if (!formula) return []
  const allowed = [...new Set(allowedMetrics.filter(Boolean))].sort(
    (left, right) => right.length - left.length,
  )
  if (!allowed.length) return []
  const expression = allowed.map(escapeRegExp).join('|')
  const matcher = new RegExp(`(?<!${IDENTIFIER})(?:${expression})(?!${IDENTIFIER})`, 'gu')
  const found = new Set<string>()
  for (const match of formula.matchAll(matcher)) found.add(match[0])
  return [...found]
}

export function chipifyFormula(formula: string, allowedMetrics: readonly string[]): string {
  const chips: string[] = []
  const placeholder = '\u0007'
  let result = formula.replace(/\[\[m:[a-zA-Z0-9_.$-]+\]\]/gu, (chip) => {
    chips.push(chip)
    return placeholder
  })
  for (const field of [...new Set(allowedMetrics.filter(Boolean))].sort(
    (left, right) => right.length - left.length,
  )) {
    const matcher = new RegExp(`(?<!${IDENTIFIER})${escapeRegExp(field)}(?!${IDENTIFIER})`, 'gu')
    result = result.replace(matcher, `[[m:${field}]]`)
  }
  let index = 0
  return result.replace(new RegExp(placeholder, 'gu'), () => chips[index++] ?? '')
}
